import { render, staticRenderFns } from "./popup_intro_avatar.vue?vue&type=template&id=1ca7c9f7&"
import script from "./popup_intro_avatar.vue?vue&type=script&lang=js&"
export * from "./popup_intro_avatar.vue?vue&type=script&lang=js&"
import style0 from "./popup_intro_avatar.vue?vue&type=style&index=0&id=1ca7c9f7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports